// iter38 — Admin Maintenance Tools page.
// Houses rarely-used admin utilities (currently: Research Cleanup) so they
// don't clutter the main /admin dashboard. Reuses the same AdminCleanupTab
// component already exported from AdminDashboard.jsx — backend endpoints
// and component logic are untouched.
import React from "react";
import { Link } from "react-router-dom";
import { CaretLeft, Broom } from "@phosphor-icons/react";
import { AgentLayout } from "@/components/AgentLayout";
import { AdminCleanupTab } from "@/pages/AdminDashboard";

export default function AdminMaintenance() {
  return (
    <AgentLayout>
      <div className="mb-8 animate-fade-up" data-testid="admin-maintenance-page">
        <Link
          to="/admin"
          className="inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.25em] text-white/40 hover:text-[#D4AF37] transition-colors font-sans mb-4"
          data-testid="back-to-admin-link"
        >
          <CaretLeft size={12} weight="bold" /> Back to dashboard
        </Link>
        <p className="text-[11px] uppercase tracking-[0.35em] text-[#D4AF37] mb-3 font-sans flex items-center gap-2">
          <Broom size={12} weight="duotone" /> Maintenance Tools
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-white mb-3">
          Admin <span className="italic text-[#D4AF37]">maintenance</span>
        </h1>
        <p className="text-white/60 text-sm max-w-2xl font-sans">
          Operational utilities for cleaning up legacy content, recovering
          itineraries, and other infrequent housekeeping tasks. These tools
          are intentionally kept off the main dashboard to keep daily
          operations focused.
        </p>
      </div>

      <AdminCleanupTab />
    </AgentLayout>
  );
}
